import { Box, Center, Heading, Icon, Tooltip } from "@chakra-ui/react";
import _ from "lodash";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import AverageSessionTimePerBranchReport from "../../../components/organization/reports/realtime/OrganizationAverageSessionTimePerBranch";
import { Helmet } from "react-helmet";
import { Info } from "lucide-react";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";

const OrganizationAverageSessionTimePerBranch = ({
  showFilterForm = false,
  reportIndex = 1,
}) => {
  const { reportRange, workDay } = useSelector((state) => state.defaultReducer);
  const reportTitle = `Average Service Time Per Branch`;
  
  return (
    <Box>
      <Helmet>
        <title>{reportTitle}</title>
      </Helmet>
      {showFilterForm ? <FilterForm /> : <></>}
      <>
        <Heading fontSize="34px" color="#222" fontWeight="700">
          {reportTitle}
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                {getReportDescription(reportRange)
                  .OrganizationAverageServiceTimePerBranch}
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
        {_.isEmpty(workDay) ? (
          <Loader />
        ) : (
          <AverageSessionTimePerBranchReport reportIndex={reportIndex} />
        )}
      </>
    </Box>
  );
};

export default OrganizationAverageSessionTimePerBranch;
